/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { useQuery } from '@apollo/client';
import { string,  number, oneOfType } from 'prop-types';
import ReactMarkdown from 'react-markdown';
import mbpLogger from 'mbp-logger';
import { makeStyles } from '@material-ui/core';
import { brandByCode } from '../../../../../../pages/Checkout/containers/CheckoutFood/components/Partials/Helper/Helper';
import findContent from '../../../../../../gql/queries/findContent';
import { GRAPHQL_ENV } from '../../../../../../gql';
import transformRenderer from '../../../../../../helpers/markdown/characterTransformer';

const useStyle = makeStyles((theme) => ({
    dividerDisclaimer: {
        borderTop: `1px solid ${theme.palette.grey8 || '#ccc'}`,
    },
}));

const MarketingSpot = ({ brandId, title }) => {
    const classes = useStyle();
    const findContentOptions = {
        brand: brandByCode[brandId],
        contentType: 'marketing_spots',
        query: `\\"title\\" : \\"${title}\\"`,
    };
    const GET_MARKETING_SPOT = findContent(findContentOptions);

    const { data, error } = useQuery(GET_MARKETING_SPOT);

    if (error) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            query: GET_MARKETING_SPOT,
            component: 'MarketingSpot.js',
            message: 'Error loading data from Graphql',
            env: GRAPHQL_ENV,
            error,
        });
        return null;
    }

    const content = data?.findContent?.content?.entries?.[0]?.spots?.[0]?.content_spot?.content || '';

    return (
        <>
            {content && <div className={classes.dividerDisclaimer} />}
            <ReactMarkdown source={content} renderers={transformRenderer} />
        </>
    );
};

MarketingSpot.propTypes = {
    brandId: oneOfType([string, number]),
    title: string,
};

MarketingSpot.defaultProps = {
    brandId: '',
    title: '',
};

export default MarketingSpot;
